import { render } from "./inspectionRecords.vue?vue&type=template&id=5fb71894&scoped=true"
import script from "./inspectionRecords.vue?vue&type=script&lang=js"
export * from "./inspectionRecords.vue?vue&type=script&lang=js"

import "./inspectionRecords.vue?vue&type=style&index=0&id=5fb71894&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5fb71894"

export default script